<script setup lang="ts">
/**
 * The yes/no a card asks a question by: two pills, the one that stands
 * filled in.
 *
 * The Girerd questionnaire, the interview sheet and the probes all ask this
 * way, so the pair is held here — and answers the same width, whichever card
 * asks. Nothing is answered locally: the card above owns the answer, and
 * hears the pick.
 */
import {pillClasses} from "@/medication-checkup/services/SceneClasses";

defineProps<{
    /**
     * The answer as it stands, null while the question is unanswered.
     */
    answer: boolean | null;
    /**
     * Whether the question is closed to answering — a frozen record.
     */
    disabled?: boolean;
}>();

const emit = defineEmits<{answer: [given: boolean]}>();

const PILL = 'px-3.5 py-1 rounded-full border-[1.5px] border-solid text-sm font-semibold disabled:opacity-60';
</script>

<template>
  <div class="flex shrink-0 gap-1.5">
    <button
      :class="[PILL, pillClasses(answer === true)]"
      :disabled="disabled"
      @click="emit('answer', true)"
    >
      Oui
    </button>
    <button
      :class="[PILL, pillClasses(answer === false)]"
      :disabled="disabled"
      @click="emit('answer', false)"
    >
      Non
    </button>
  </div>
</template>
